import { Box, Typography, useTheme } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { Button } from '@mui/material'
import { tokens } from '../../theme'
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined'
import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined'
import Header from '../../components/Header'
import React from "react"
import { useState, useEffect } from "react"
import { ptBR as ptBRGrid } from '@mui/x-data-grid'
import { useNavigate } from 'react-router-dom'

import * as Constants from '../../constants'

const Team = () => {
  const theme = useTheme()
  const colors = tokens(theme.palette.mode)

  const [rows, setRows] = useState([])
  const [selectedRows, setSelectedRows] = useState([])

  const handleSetOwner = (e) => {
    if (selectedRows == null || selectedRows.length === 0) {
      alert(
        'Selecione pelo menos um usuário para atribuir um novo proprietário.'
      )
      return
    }

    var str = ''
    selectedRows.forEach((row) => {
      console.log(row)
      str += row.username + ','
    })

    navigate('/set-owner/' + str)
  }

  const fetchUsers = () => {
    fetch(Constants.HOST + '/users', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        token: JSON.parse(localStorage.getItem('user_data')).token,
      }),
    })
      .then((response) => {
        if (response.status === 200) {
          response.json().then((data) => {
            data = data.data
            let newRows = []
            if (typeof data.users === 'object') {
              data.users.forEach((user) => {
                newRows.push({
                  id: user.id,
                  username: user.username,
                  owners: user.owner_names,
                  admin: user.is_admin,
                })
              })
            }

            setRows(newRows)
          })
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  useEffect(() => {
    fetchUsers()
  }, [])

  const columns = [
    {
      field: 'username',
      headerName: 'Nome de usuário',
      flex: 1,
      cellClassName: 'name-column--cell',
    },
    { field: 'owners', headerName: 'Proprietários', flex: 2 },
    {
      field: 'is_admin',
      headerName: 'Nível de acesso',
      flex: 1,
      renderCell: ({ row: { admin } }) => {
        return (
          <Box
            width="40%"
            m="0 auto"
            p="10px"
            display="flex"
            justifyContent="center"
            borderRadius="4px"
          >
            {admin ? (
              <AdminPanelSettingsOutlinedIcon />
            ) : (
              <SecurityOutlinedIcon />
            )}
            <Typography color={colors.grey[100]} sx={{ ml: '5px' }}>
              {admin ? 'Adminstrador' : 'Operador'}
            </Typography>
          </Box>
        )
      },
    },
    {
      field: 'actions',
      headerName: '',
      flex: 1,
      renderCell: ({ row: { id } }) => {
        return (
          <Box justifyContent="right" sx={{ flexGrow: 1, display: 'flex' }}>
            <Button
              variant="contained"
              sx={{ mr: '5px' }}
              onClick={() =>
                navigate(`/edit/${rows.find((row) => row.id === id).username}`)
              }
            >
              {' '}
              Editar{' '}
            </Button>
            <Button
              variant="contained"
              onClick={() => navigate(`/del-user/${id}`)}
            >
              {' '}
              Excluir{' '}
            </Button>
          </Box>
        )
      },
    },
  ]

  let navigate = useNavigate()
  const handleAddUser = () => {
    navigate('/add-user')
  }

  return (
    <Box m="20px">
      <Box mb="20px" display="flex" justifyContent="space-between">
        <Box display="grid" gridColumn="span 6" justifyContent="space-between">
          <Header title="Time" subtitle="Gerencie os membros" />
        </Box>
        <Box m="20px 0" gridColumn="span 6" justifyContent="flex-end">
          <Button
            variant="contained"
            color="warning"
            onClick={handleAddUser}
            sx={{ mr: '5px' }}
          >
            Criar novo usuário
          </Button>
          <Button variant="contained" color="success" onClick={handleSetOwner}>
            Alterar proprietários (usuários selecionados)
          </Button>
        </Box>
      </Box>
      <Box
        m="20px 0 0 0"
        height="75vh"
        sx={{
          '& .MuiDataGrid-root': {
            border: 'none',
          },
          '& .MuiDataGrid-cell': {
            borderBottom: 'none',
          },
          '& .name-column--cell': {
            color: colors.greenAccent[300],
          },
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: colors.blueAccent[700],
            borderBottom: 'none',
          },
          '& .MuiDataGrid-virtualScroller': {
            backgroundColor: colors.primary[400],
          },
          '& .MuiDataGrid-footerContainer': {
            borderTop: 'none',
            backgroundColor: colors.blueAccent[700],
          },
          '& .MuiCheckbox-root': {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      >
        <DataGrid
          checkboxSelection
          rows={rows}
          columns={columns}
          localeText={ptBRGrid.components.MuiDataGrid.defaultProps.localeText}
          onSelectionModelChange={(ids) =>
            setSelectedRows(ids.map((id) => rows.find((row) => row.id === id)))
          }
        />
      </Box>
    </Box>
  )
}

export default Team
